<template>
  <tr @click.stop="">
    <td style="width: 50%" @click.stop="">
      <a-select style="width: 100%" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="(device, index) in groupDrawer.deviceList" :key="device.id" :value="device.deviceCode" @click="showDataList(device, index)">
          {{device.deviceName}}
        </a-select-option>
      </a-select>
    </td>
    <td style="width: 50%">
      <a-select style="width: 100%" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="menuData in menuDataList" :key="menuData.code" :value="menuData.code" @click="recordeMenuData(menuData)">
          {{menuData.name}}
        </a-select-option>
      </a-select>
    </td>
  </tr>
</template>

<script>
import { protocolApi } from '@/api/station'
export default {
  name: 'Tr',
  props: ['groupDrawer', 'dataType', 'setData', 'rowCount', 'index'],
  data () {
    return {
      menuDataList: [],
      deviceIndex: 0,
      menuDataIndex: 0
    }
  },
  created () {
    console.log(this.groupDrawer)
    console.log(this.dataType)
    console.log(this.index)
  },
  methods: {
    async showDataList (device, index) {
      this.menuDataList = []
      try {
        const data = await protocolApi.get(device.driverType, device.protocolCode)
        this.menuDataList = data.data.points
      } catch {
        // this.$message.error("请求失败")
      }
      this.deviceIndex = index
      console.log(this.index)
    },
    recordeMenuData (menuData) {
      console.log(this.index)
      this.setData(this.dataType, {
        deviceCode: this.groupDrawer.deviceList[this.deviceIndex].deviceCode,
        data: menuData.code
      }, this.index)
    }
  }
}
</script>

<style scoped>
.ant-select-arrow .ant-select-arrow-icon {
    color: #fff;
  }
  .ant-select-dropdown-menu-item {
    color: #fff !important;
  }
  .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected {
    background-color: #485464 !important;
    color: #fff !important;
  }
  .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected:hover {
    color: #333 !important;
  }
  .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-active {
    background-color: #A7ADB5 !important;
    color: #333 !important;
  }
  .ant-select-dropdown-menu-item:hover {
    background-color: #A7ADB5 !important;
    color: #333 !important;
  }
</style>
